import MadeInUSA from "@/images/made-in-usa.svg";
import { cn } from "@/utils/cn";
import Image from "next/image";
import PriceLabel from "../price-label";

export function GridTileImage({
  isInteractive = true,
  active,
  label,
  ...props
}: {
  isInteractive?: boolean;
  active?: boolean;
  label?: {
    title: string;
    amount: string;
    currencyCode: string;
    position?: "bottom" | "center";
  };
} & React.ComponentProps<typeof Image>) {
  return (
    <div
      className={cn(
        "group flex h-full w-full items-center justify-center overflow-hidden rounded-xs border bg-[#F4F3EF] hover:border-primary dark:bg-black",
        {
          relative: label,
          "border-2 border-primary": active,
          "border-neutral-200 dark:border-neutral-800": !active,
        },
      )}
    >
      {props.src ? (
        <Image
          className={cn("relative h-full w-full object-contain", {
            "scale-70 transition duration-300 ease-in-out group-hover:scale-75": isInteractive,
          })}
          {...props}
        />
      ) : null}
      {label ? (
        <PriceLabel
          title={label.title}
          amount={label.amount}
          currencyCode={label.currencyCode}
          position={label.position}
        />
      ) : null}
      <Image
        src={MadeInUSA}
        className="absolute top-2 right-5 z-20 h-10 w-10"
        alt="Made in the USA"
      ></Image>
    </div>
  );
}
